(function () {
  const HANDLING_FEE_VARIANT_ID = 54913864991042;
  const MIN_SUBTOTAL = 1000.0;
  const SAMPLES_VENDOR = "Samples";

  async function getCart() {
    const res = await fetch("/cart.js");
    return res.json();
  }

  async function removeFee(lineIndex) {
    await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ line: lineIndex, quantity: 0 }),
    });
  }

  async function addFee() {
    await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        items: [{ id: HANDLING_FEE_VARIANT_ID, quantity: 1 }],
      }),
    });
  }

  async function syncHandlingFee() {
    const cart = await getCart();
    const lines = cart.items;

    const feeLineIndex = lines.findIndex(
      (item) => item.variant_id === HANDLING_FEE_VARIANT_ID
    );
    const hasFee = feeLineIndex !== -1;

    const eligibleSubtotal = lines.reduce((sum, item) => {
      if (item.variant_id === HANDLING_FEE_VARIANT_ID) return sum;
      if (item.vendor === SAMPLES_VENDOR) return sum;
      return sum + item.line_price;
    }, 0) / 100;

    console.log("[HandlingFee] subtotal:", eligibleSubtotal, "hasFee:", hasFee);

    if (eligibleSubtotal >= MIN_SUBTOTAL) {
      if (hasFee) {
        await removeFee(feeLineIndex + 1);
        if (window.location.pathname === "/cart") location.reload();
      }
    } else {
      if (lines.length > 0 && !hasFee) {
        await addFee();
        if (window.location.pathname === "/cart") location.reload();
      }
    }
  }

  // Run on every page
  syncHandlingFee();

  // Re-run when cart changes
  document.addEventListener("cart:updated", syncHandlingFee);
  document.addEventListener("cart:refresh", syncHandlingFee);

})();
